type Position = 'top-right' | 'bottom-right' | 'bottom-left'
type Listener = (position: Position) => void

const listeners: Listener[] = []

export const environmentIndicatorEvents = {
  setPosition: (position: Position): void => {
    listeners.forEach((listener) => listener(position))
  },
  subscribe: (listener: Listener): (() => void) => {
    listeners.push(listener)
    return () => {
      const index = listeners.indexOf(listener)
      if (index !== -1) {
        listeners.splice(index, 1)
      }
    }
  },
}
